import React from 'react';
import SingleValueRadial from '@splunk/dashboard-visualizations/SingleValueRadial';

export default () => (
    <SingleValueRadial
        options={{}}
        encoding={{
            trend: 'primary.foo',
            fill: 'primary[1][2]',
        }}
        dataSources={{
            primary: {
                data: {
                    columns: [
                        ['1', '62', '103', '308', '587', '876', '930', '1320'],
                        [
                            '#FF0000',
                            '#00FFFF',
                            '#0000FF',
                            '#800080',
                            '#FFFF00',
                            '#FFA500',
                            '#A52A2A',
                            '#008000',
                        ],
                    ],
                    fields: [
                        {
                            name: 'foo',
                        },
                        {
                            name: 'bar',
                        },
                    ],
                },
                meta: {},
            },
        }}
    />
);
